import apiOptions from '@/api/public/options';

const defaultState = () => ({
	courier: [],
	ongkir: [],
	provinces: [],
	cities: [],
	subdistricts: [],
	listBank: [],
	bankAccountList: [],
	supportBankList: [],
	paymentMethodList: [],
    memberType: [
    {
        "label": "Silver",
        "value": "silver"
    },
    {
        "label": "Gold",
        "value": "sold"
    },
    {
        "label": "Platinum",
        "value": "platinum"
    }
],
});

const state = defaultState();

const getters = {
};

const mutations = {
	setMemberType(state, data) {
	  state.memberType = data;
	},
	setCourier(state, data) {
		state.courier = data
	},
	setOngkir(state, data) {
		state.ongkir = data
	},
	setProvince(state, data) {
		state.provinces = data
	},
	setCity(state, data) {
		state.cities = data
	},
	setSubdistrict(state, data) {
		state.subdistricts = data
	},
	setListBank(state, data) {
		state.listBank = data
	},
	setBanAccountList(state, data) {
		state.bankAccountList = data
	},
	setSupportBankList(state, data) {
		state.supportBankList = data
	},
	setPaymentMethodList(state, data) {
		state.paymentMethodList = data
	},
	clearOptions(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getSupportBank({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getSupportBank(params).then(({ data: { data } }) => {
				commit('setSupportBankList', data.results);
				resolve(true);
			}).catch(() => {
				commit('setSupportBankList', []);
			});
		});
	},
	async getCourier({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getCourier(params).then(({ data: { data } }) => {
				commit('setCourier', data.results);
				resolve(true);
			}).catch(() => {
				commit('setCourier', []);
			});
		});
	},
	async getTipeMember({ commit }, params) { 
		return new Promise((resolve) => {
			apiOptions
			.getTipeMember(params)
			.then(({ data: { data } }) => { 
			  commit("setMemberType", data);
			  resolve(true);
			})
			.catch(() => {
			  commit("setMemberType", { data: [], });
			})
		});
	  },
	async getOngkir({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getOngkir(params).then(({ data: { data } }) => {
				commit('setOngkir', data.results);
				resolve(data.results);
			}).catch(() => {
				commit('setOngkir', []);
			});
		});
	},
	async getProvince({ commit }) {
		return new Promise((resolve) => {
			apiOptions.getProvince().then(({ data: { data } }) => {
				commit('setProvince', data.results);
				resolve(true);
			}).catch(() => {
				commit('setProvince', []);
			});
		});
	},
	async getCity({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getCity(params).then(({ data: { data } }) => {
				commit('setCity', data.results);
				resolve(true);
			}).catch(() => {
				commit('setCity', []);
			});
		});
	},
	async getSubdistrict({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getSubdistrict(params).then(({ data: { data } }) => {
				commit('setSubdistrict', data.results);
				resolve(true);
			}).catch(() => {
				commit('setSubdistrict', []);
			});
		});
	},
	async getBankList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getBankList(params).then(({ data: { data } }) => {
				commit('setListBank', data.results);
				resolve(true);
			}).catch(() => {
				commit('setListBank', []);
			});
		});
	},
	async getBankAccountList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getBankAccountList(params).then(({ data: { data } }) => {
				commit('setBanAccountList', data.results);
				resolve(data.results);
			}).catch(() => {
				commit('setBanAccountList', []);
			});
		});
	},
	async getPaymentMethodList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getPaymentMethodList(params).then(({ data: { data } }) => {
				commit('setPaymentMethodList', data.results);
				resolve(true);
			}).catch(() => {
				commit('setPaymentMethodList', []);
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};